import { useEffect, useRef, type ReactNode } from "react";
import { useMainButton } from "../mainButton.ts";
import { pushBackHandler } from "../telegram.ts";

/** Открытые листы: Esc закрывает только верхний. */
const openSheets: (() => void)[] = [];

/** Нижняя панель поверх экрана. Закрывается фоном, Esc и системной кнопкой «Назад» Telegram. */
export function Sheet({ title, onClose, children }: { title: string; onClose: () => void; children: ReactNode }) {
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    const close = () => closeRef.current();
    openSheets.push(close);
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && openSheets.at(-1) === close && close();
    window.addEventListener("keydown", onKey);
    const popBack = pushBackHandler(close);
    return () => {
      window.removeEventListener("keydown", onKey);
      openSheets.splice(openSheets.indexOf(close), 1);
      popBack();
    };
  }, []);

  return (
    <div className="sheet-backdrop" onClick={onClose}>
      <div className="sheet" role="dialog" aria-label={title} onClick={(e) => e.stopPropagation()}>
        <div className="sheet-handle" />
        <h2 className="sheet-title">{title}</h2>
        {children}
      </div>
    </div>
  );
}

/**
 * Главная кнопка листа: в Telegram — системная нижняя кнопка, в браузере — кнопка,
 * прилипшая к низу листа.
 */
export function PrimaryAction({ label, onClick, busy, disabled }: { label: string; onClick: () => void; busy?: boolean; disabled?: boolean }) {
  const own = useMainButton(label, onClick, { enabled: !disabled && !busy, loading: busy });
  if (!own) return null;
  return (
    <div className="sheet-footer">
      <button type="button" className="btn btn-primary btn-block" disabled={busy || disabled} onClick={onClick}>
        {busy ? "…" : label}
      </button>
    </div>
  );
}
